// React
import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";

// Utilities
import toast from "react-hot-toast";
import cookie from "react-cookies";

import { verifyOtp } from "../Request/LoginRequests";

// Redux actions
import {
  saveAddress,
  saveUser,
  setCurrentLocation,
} from "../Redux/Actions/userActions";
import {
  getNotificationStatus,
  updateLoginState,
} from "../Request/UserRequests";
import { requestOtp, addNewUser } from "../Request/LoginRequests";
import Input from "../Others/Input";
import verifyOtpImg from "../img/varify_no_img.png";
import refreshOtp from "../img/loader.gif";
import resendOtpImg from "../img/refresh.png";

/**
 * Verify Phone No. Popup
 * @param {String} phn Phone no. passed from top level component
 * @returns {JSX}
 */
export default function Verify({ phn }) {
  const { t } = useTranslation();
  const [otp, setotp] = useState("");
  const [load, setLoad] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const search = useLocation().search;
  const freeProduct = new URLSearchParams(search).get("signup");
  const user = useSelector((s) => s.user.info);

  useEffect(() => {
    return () => setLoad(false);
  }, []);

  function handleVerifyOtp() {
    setLoad(true);
    verifyOtp(phn, otp)
      .then((res) => {
        if (res.newUser) {
          if (freeProduct !== null) {
            localStorage.setItem("phn", phn);
            navigate("/Rashan-4/freeproduct");
          } else {
            localStorage.setItem("phn", phn);
            dispatch(saveUser({ ...user, phn: phn }));
            addNewUser(phn)
              .then((res) => {
                document.getElementById("click").click();
                document.getElementById("area").classList.toggle("d-none");
              })
              .catch((err) => {
                toast.success(err);
              });
            // document.getElementById("signup").classList.toggle("hide-2");
          }
        } else {
          // toast.success("Otp Verified");
          let auth = localStorage.getItem("auth");
          if (auth) {
            getNotificationStatus(auth, res.user.userHash).then((notify) => {
              dispatch(
                saveUser({ ...res.user, notification: notify?.notification })
              ); // save user
            });
            updateLoginState(true, res.user.userHash).catch((err) =>
              console.log(err)
            );
          } else dispatch(saveUser({ ...res.user, notification: false })); // save user

          dispatch(saveAddress(res.address)); // save user addresses
          // save user's primary address
          dispatch(
            setCurrentLocation(
              res.address?.filter((a) => a.primary === "true")?.[0] //filter out primary address
            )
          );
          // save user in cookie
          cookie.save("uid", res.user.userHash, {
            path: "/",
            expires: new Date(new Date().setDate(new Date().getDate() + 360)),
          });
          setLoad(false);
          navigate("/home"); // send to home page
        }
      })
      .catch((err) => {
        setLoad(false);
        toast.error(err);
        // errorToggle()
      });
  }

  const STATUS = {
    STARTED: "Started",
    STOPPED: "Stopped",
  };

  const INITIAL_COUNT = 120;

  const [secondsRemaining, setSecondsRemaining] = useState(INITIAL_COUNT);
  const [status, setStatus] = useState(STATUS.STOPPED);

  const secondsToDisplay = secondsRemaining % 60;
  const minutesRemaining = (secondsRemaining - secondsToDisplay) / 60;
  const minutesToDisplay = minutesRemaining % 60;
  const hoursToDisplay = (minutesRemaining - minutesToDisplay) / 60;

  const handleStart = () => {
    setStatus(STATUS.STARTED);
  };
  // const handleStop = () => {
  //   setStatus(STATUS.STOPPED);
  // };
  const handleReset = () => {
    setStatus(STATUS.STOPPED);
    setSecondsRemaining(INITIAL_COUNT);
  };
  useInterval(
    () => {
      if (secondsRemaining > 0) {
        setSecondsRemaining(secondsRemaining - 1);
      } else {
        setStatus(STATUS.STOPPED);
        document.getElementById("receiveOTP").classList.toggle("d-none");
        document.getElementById("resendOTP").classList.toggle("d-none");
      }
    },
    status === STATUS.STARTED ? 1000 : null
    // passing null stops the interval
  );

  function handleSendOtp() {
    setLoad(true); // set state to loading

    requestOtp(phn) // otp request
      .then(() => {
        //toast.success("OTP sent");

        // Hide login and show verify
        document.getElementById("receiveOTP").classList.toggle("d-none");
        document.getElementById("resendOTP").classList.toggle("d-none");
        document.getElementById("enterOTP").focus();
        document.getElementById("countReset").click();
        document.getElementById("countStart").click();
      })
      .catch((err) => toast.error(err))
      .finally(() => setLoad(false));
  }

  return (
    // Verify Otp Popup
    <div
      className="bg-white overflow-hidden hide animate"
      style={{
        padding: "42px 16px 0",
        transition: "ease 0.5s",
        width: "100vw",
        height: "100vh",
        position: "absolute",
        right: "0",
        top: "0",
      }}
      id="verify"
    >
      <button
        onClick={handleReset}
        type="button"
        id="countReset"
        style={{
          width: "0",
          height: "0",
          opacity: "0",
          visibility: "hidden",
          position: "absolute",
        }}
      ></button>
      <button
        onClick={handleStart}
        type="button"
        id="countStart"
        style={{
          width: "0",
          height: "0",
          opacity: "0",
          visibility: "hidden",
          position: "absolute",
        }}
      ></button>
      {/* Header */}
      <h2
        style={{
          fontSize: "24px",
          fontWeight: "700",
          margin: "0 0 22px",
          color: "#2B2B2B",
        }}
      >
        {t("Verify OTP")}
      </h2>
      <img
        src={verifyOtpImg}
        alt=""
        width={134}
        className="d-block mx-auto"
        style={{ marginBottom: "24px" }}
      />
      <div
        style={{
          marginBottom: "8px",
          color: "#2B2B2B",
          fontSize: "14px",
          lineHeight: "150%",
        }}
      >
        {t("Please enter 4 digit OTP code sent to your mobile number")}{" "}
        <strong>+91-{phn}</strong> ️{" "}
        <a
          href="javascript:void(0);"
          onClick={() => {
            document.getElementById("verify").classList.toggle("hide");
            document.getElementById("login").classList.toggle("hide");

            document.getElementById("receiveOTP").classList.toggle("d-none");
            document.getElementById("resendOTP").classList.toggle("d-none");
            document.getElementById("countReset").click();
          }}
          style={{
            fontSize: "14px",
            color: "2278FF",
            textTransform: "uppercase",
          }}
        >
          {t("Edit")}
        </a>
      </div>

      <div className="bg-white">
        {/* OTP input */}
        <div className="otpverify">
          <Input
            id="enterOTP"
            value={otp}
            autoComplete="off"
            autoFocus={true}
            dotPrecision={0}
            isAllowed={({ value }) =>
              (value > 0 && value < Math.pow(10, 4)) || value === ""
            }
            onChange={(e) => setotp(e.target.value)}
          />
          {/* <FloatingLabelInput
            id="otp"
            type="number"
            className="fs-5 floating-label"
            onChange={(e) => handleInput(e, setotp)}
            onKeyDown={(e) => handleKeyPress(e, otp, 4)}
          /> */}
          {/* { showError ? <Errors /> : null } */}
        </div>

        <div id="receiveOTP" className="d-none">
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ marginBottom: "24px", padding: "8px 0" }}
          >
            <img
              src={refreshOtp}
              alt=""
              width={18}
              className="d-block"
              style={{ marginRight: "8px" }}
            />
            <p
              style={{
                margin: "0",
                fontSize: "12px",
                color: "#666666",
                fontWeight: "500",
                paddingRight: "8px",
              }}
            >
              {t("Receiving OTP in")}{" "}
              <span style={{ color: "#2B2B2B", fontSize: "12px" }}>
                00:{twoDigits(secondsToDisplay)}
              </span>
            </p>
          </div>
        </div>

        <div id="resendOTP" className="">
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ marginBottom: "24px", padding: "8px 0" }}
            onClick={handleSendOtp}
          >
            <img
              src={resendOtpImg}
              alt=""
              width={16}
              className="d-block"
              style={{ marginRight: "2px" }}
            />
            <p
              style={{
                margin: "0",
                fontSize: "12px",
                color: "#2278FF",
                fontWeight: "500",
                paddingRight: "8px",
              }}
            >
              {t("Resend OTP")}
            </p>
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex">
          {/* Verify OTP button */}
          <button
            disabled={load || !/^[1-9]{1}[0-9]{3}$/.test(otp)}
            className="btn-cnf btn-orange w-100 animate-2"
            onClick={handleVerifyOtp}
          >
            {load ? t("Verifying...") : t("Continue")}
          </button>

          {/* Change Phn no button */}
        </div>
      </div>
    </div>
  );
}
function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

const twoDigits = (num) => String(num).padStart(2, "0");
